import React, {Component} from 'react';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';
import PropTypes from 'prop-types';

import teslaAuthApi from '../../api/teslaAuthApi';
import teslaOAuthApi from '../../api/teslaOAuthApi';

import Subscriptions from '../Subscriptions';
import Preferences from '../Preferences';

// Tesla Auth Status
import withTeslaAuthStatus from '../../components/withTeslaAuthStatus';

import { loadTeslaAuthStatus } from '../../actions/teslaAuthStatusActions';
import { loadTeslaVehicles } from '../../actions/teslaVehicleActions';

class Settings extends Component {
  constructor(props) {
    super(props);
	
    this.toggleTeslaCredentials = this.toggleTeslaCredentials.bind(this);
    this.update = this.update.bind(this);
    this.state = { collapseTeslaCredentials: false };
  }

  toggleTeslaCredentials() {
	event.preventDefault();
	  
    this.setState({ collapseTeslaCredentials: !this.state.collapseTeslaCredentials });
  }
  
  componentWillMount(nextProps) {
	var isValid = (this.context.teslaAuthStatus.status === 'valid');
	  
	this.setState({
		collapseTeslaCredentials: isValid
	});
  }

	componentWillReceiveProps(nextProps) {
		var isValid = (this.context.teslaAuthStatus.status === 'valid');
	  
		this.setState({
			collapseTeslaCredentials: isValid
		});
	}

  update(event) {
	  event.preventDefault();
	  
	  var emailElement = document.getElementById('email');
	  var email = emailElement.value;
	  
	  var passwordElement = document.getElementById('password');
	  var password = passwordElement.value;
	  
	  var teslaAuth = {};
	  teslaAuth.email = email;
	  teslaAuth.password = password;
	  
	  const {
	  	store,
		authToken
	  } = this.context;
		  
	  teslaAuthApi.updateTeslaAuth('deviceId', this.context.authToken, teslaAuth).then((json) => {
		  passwordElement.value = '';
	  
		  if (json.error) {
	  	  	  alert("Could not update Tesla authentication");
		  } else {
			  emailElement.value = '';
	  	  	  alert("Updated Tesla authentication");
			  
		  	  this.setState({
		  		collapseTeslaCredentials: true
		  	  });

			  store.dispatch(loadTeslaAuthStatus('deviceId', authToken));
			  store.dispatch(loadTeslaVehicles('deviceId', authToken));
		  }
	  }).catch(error => {
		console.log(error);
	  	alert("Could not update Tesla authentication");
	  })
  }

  render() {
    return (
      <div className="animated fadeIn">
      <Row>
		<Col>
			<Subscriptions/>
		</Col>
      </Row>
      <Row>
		<Col>
			<Preferences/>
		</Col>
        <Col xs="12" sm="6">
            <Card>
              <CardHeader>
                <strong>Tesla Credentials</strong>
              </CardHeader>
			  <TeslaCredentialsConfigured toggleTeslaCredentials={this.toggleTeslaCredentials} show={this.state.collapseTeslaCredentials}/>
			  <TeslaCredentialsEmailPassword show={!this.state.collapseTeslaCredentials}/>
              <CardFooter>
			  <TeslaCredentialsUpdate update={this.update} show={!this.state.collapseTeslaCredentials}/>
              </CardFooter>
            </Card>
        </Col>
      </Row>
      </div>
    )
  }
}

function TeslaCredentialsConfigured(props) {
	if (!props.show) {
		return null;
	}
	
	return (
      <CardBody>
		<p>Your Tesla credentials are configured.</p>
		<p><a href="#" onClick={props.toggleTeslaCredentials}>Update Tesla Credentials</a></p>
      </CardBody>
	);
}

function TeslaCredentialsEmailPassword(props) {
	if (!props.show) {
		return null;
	}
	
	return (
      <CardBody>
        <FormGroup row>
          <Col xs="12" md="9">
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="icon-user"></i>
                </InputGroupText>
              </InputGroupAddon>
              <Input type="username" id="email" name="email" placeholder="Email"/>
            </InputGroup>
          </Col>
		</FormGroup>
		<FormGroup row>
          <Col xs="12" md="9">
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="icon-lock"></i>
                </InputGroupText>
              </InputGroupAddon>
              <Input type="password" id="password" name="password" placeholder="Password"/>
            </InputGroup>
          </Col>
        </FormGroup>
		<small>Your Tesla email and password will pass through
		SenseEV servers to Tesla servers for verification. When verified,
		Tesla servers return authentication and refresh tokens to be used in subsequent actions.
		SenseEV only stores these tokens, not your email and password. 
		Your email and password are passed through SenseEV servers because <a href="https://en.wikipedia.org/wiki/Cross-origin_resource_sharing">CORS</a> rules 
		prevent web applications from reading data from one server (e.g., Tesla) and sending that data to another server (e.g., SenseEV).
		If you would prefer not to pass your email and password through SenseEV servers, then please use a SenseEV
		mobile app to update your Tesla credentials. Mobile apps are not restricted by <a href="https://en.wikipedia.org/wiki/Cross-origin_resource_sharing">CORS</a> rules
		so they may read data from Tesla servers and send it to SenseEV servers.
		</small>
      </CardBody>
	);
}

function TeslaCredentialsUpdate(props) {
	if (!props.show) {
		return null;
	}
	
	return (
    	<Button type="submit" size="sm" color="primary" onClick={props.update}><i className="fa fa-dot-circle-o"></i> Update</Button>
	);
}

Settings.contextTypes = {
	authToken: PropTypes.string.isRequired,
	teslaAuthStatus: PropTypes.object.isRequired,
	store: PropTypes.object.isRequired
}

export default withTeslaAuthStatus(Settings);



// WEBPACK FOOTER //
// ./src/views/Settings/Settings.js